import { render, staticRenderFns } from "./CommentGroupEdit.vue?vue&type=template&id=071720d2"
import script from "./CommentGroupEdit.vue?vue&type=script&lang=js"
export * from "./CommentGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports